/**
 * Homepage v1/v2 switch (build F4). The server decides the version per
 * request (app flag `homepageV2Enabled`, else env `HOMEPAGE_VERSION`, else v1)
 * and bakes it into the served HTML as `window.__PP_HOMEPAGE__`, so `/` never
 * flashes the wrong page. In development (no server-side injection) the client
 * asks `GET /api/public/homepage-version` instead.
 */
export type HomepageVersion = "v1" | "v2";

export const HOMEPAGE_VERSION_GLOBAL = "__PP_HOMEPAGE__";
export const HOMEPAGE_VERSION_ENDPOINT = "/api/public/homepage-version";

export function isHomepageVersion(value: unknown): value is HomepageVersion {
  return value === "v1" || value === "v2";
}

/** The version baked into the page by the server, if any. */
export function injectedHomepageVersion(): HomepageVersion | null {
  if (typeof window === "undefined") return null;
  const value = (window as unknown as Record<string, unknown>)[HOMEPAGE_VERSION_GLOBAL];
  return isHomepageVersion(value) ? value : null;
}

/** `<script>` that sets the global; the value is validated before it is written. */
export function homepageVersionScript(version: HomepageVersion): string {
  return `<script>window.${HOMEPAGE_VERSION_GLOBAL}=${JSON.stringify(version)};</script>`;
}
